<template>
  <EditorLayoutSection :parentModule="parentModule"/>
</template>

<script>
  import EditorLayoutSection from '@/components/EditorLayoutSection'
  export default {
    components: {EditorLayoutSection},
    computed: {
      parentModule() {
        return 'topSectionModule'
      },
      topSection() {
        return this.$store.getters[`${this.parentModule}/elements`]()
      }
    },
  }
</script>